import * as React from 'react'
import { useUsage } from './useUsage'
import { usePaywallStore } from './usePaywallStore'

// The free-tier usage chip. Never mounted in the global header: it lives in
// contextual surfaces only — the graph list, the subscription page and the
// last-free-graph hint. Lifetime
// numbers, no reset date. Renders nothing for paid or unknown tiers.
export default function UsageChip({
    placement = 'subscription',
    lockedCount = 0,
    total = null,
}) {
    const { usage, isFree } = useUsage()
    const openUpgradeDialog = usePaywallStore(state => state.openUpgradeDialog)
    const [expanded, setExpanded] = React.useState(false)

    if (!isFree) return null
    const graphs = usage.graphsCreated
    const chats = usage.chatsStarted
    if (typeof graphs?.limit !== 'number' || typeof chats?.limit !== 'number') {
        return null
    }

    const summary =
        placement === 'graph-list' &&
        lockedCount > 0 &&
        typeof total === 'number'
            ? `Free · ${total} graphs (${lockedCount} locked)`
            : `Free · ${graphs.used}/${graphs.limit} graphs created · ${chats.used}/${chats.limit} AI chats`

    return (
        <div className="project-notes-scope">
            <div
                className="tw-inline-flex tw-max-w-full tw-flex-col tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-card tw-px-3 tw-py-2 tw-text-sm tw-text-foreground"
                data-testid="usage-chip"
                data-placement={placement}
            >
                <button
                    type="button"
                    onClick={() => setExpanded(value => !value)}
                    aria-expanded={expanded}
                    className="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0 tw-text-left tw-text-sm tw-font-medium tw-text-foreground"
                >
                    {summary}
                </button>
                {expanded ? (
                    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
                        <span className="tw-text-muted-foreground">
                            Lifetime allowance on the free plan
                        </span>
                        <button
                            type="button"
                            onClick={() =>
                                openUpgradeDialog({
                                    code: 'MENU',
                                    trigger: 'menu',
                                })
                            }
                            data-testid="usage-chip-upgrade"
                            className="tw-cursor-pointer tw-rounded-md tw-border-0 tw-bg-primary tw-px-3 tw-py-1 tw-text-xs tw-font-semibold tw-text-primary-foreground"
                        >
                            Upgrade
                        </button>
                    </div>
                ) : null}
            </div>
        </div>
    )
}
